module.exports = __webpack_public_path__ + "static/media/bedThreeFourths.4f43c6c8.png";